// Re-export shim: the RM model now lives in per-BMM-package modules.
// See ./mod.ts and tasks/split_model_by_bmm_packages.ts.

export * from "./mod.ts";
